module.exports = __webpack_public_path__ + "static/img/xian.c00278ef.png";